import asyncComponent from '../common/utils/async-component';

const AgentNav = asyncComponent(async () => import('./components/agent-nav'));
const AgentDashboard = asyncComponent(async () => import('./components/agent-dashboard'));
const AgentSummary = asyncComponent(async () => import('./components/agent-summary'));
const Sessions = asyncComponent(async () => import('./components/sessions'));
const Messages = asyncComponent(async () => import('./components/messages'));
const AgentPreview = asyncComponent(async () => import('./components/agent-preview'));
const AgentTranscripts = asyncComponent(async () => import('./components/agent-transcripts'));
const AgentTranscriptCreate = asyncComponent(async () => import('./components/agent-transcript-create'));
const AgentTranscriptEdit = asyncComponent(async () => import('./components/agent-transcript-edit'));
const ContentNav = asyncComponent(async () => import('../common/components/nav/content-nav'));
const AgentEvals = asyncComponent(async () => import('./components/agent-evals'));

export default {
  '/agents': {
    components: { main: AgentDashboard, nav: AgentNav },

    '/:agentName': {
      components: { main: AgentSummary, nav: AgentNav },

      '/sessions': {
        components: { main: Sessions, nav: AgentNav },

        '/:sessionId': {
          components: { main: Messages, nav: AgentNav }
        }
      },

      '/preview': {
        components: { main: AgentPreview, nav: AgentNav }
      }
    }
  },
  '/transcripts': {
    components: { main: AgentTranscripts, nav: ContentNav },

    '/create': {
      components: { main: AgentTranscriptCreate, nav: ContentNav }
    },

    '/edit/:transcriptId': {
      components: { main: AgentTranscriptEdit, nav: ContentNav }
    }
  },
  '/evals': {
    components: { main: AgentEvals, nav: AgentNav }
  }
};
